import { Component, NgModule , OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef,
  OnChanges, TemplateRef, ViewChild} from '@angular/core';
import {DemoService} from '../../../demo.service';

import { MysqlService } from './../../../services/mysql.service';

import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpRequest, HttpResponse, HttpEvent } from '@angular/common/http';

// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import {BehaviorSubject, Observable, Subject, map} from 'rxjs';


import { FileUploaderService } from './../../../services/file-uploader-service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { GlobalFunctionsService } from './../../../services/global-functions.service';
import { JobPlaintiff } from './../../../shared/models/jobPlaintiff.model';
import { AllRecipients } from './../../../shared/models/allRecipients.model';

import { SubjectCommunication } from '../../../shared/models/subjectCommunication.model';
import { SubjectCommunicationAttatchments } from '../../../shared/models/subjectCommunicationAttachments.model';

import * as $ from 'jquery';
// see: https://www.youtube.com/watch?v=YPBcy6LSxsg

import {
  ToolbarService,
  LinkService,
  ImageService,
  HtmlEditorService,
} from '@syncfusion/ej2-angular-richtexteditor';
import {
  RichTextEditorComponent,
  NodeSelection,
} from '@syncfusion/ej2-angular-richtexteditor';
import { DialogUtility } from '@syncfusion/ej2-angular-popups';
import { HotToastService } from '@ngneat/hot-toast';

@Component({
  selector: 'app-send-email-widget',
  templateUrl: './send-email-widget.component.html',
  styleUrls: ['./send-email-widget.component.css'],
  providers: [
    ToolbarService,
    LinkService,
    ImageService,
    HtmlEditorService,
  ],
})
export class SendEmailWidgetComponent implements OnInit {
  // setup as observable?
  // @Input() item_id?: Observable<any[]>; // impliments on changes.
  // @Input() item_data?: Observable<any[]>; // if data.model is sent : Observable<any[]>;


  @Input() item_id?; // impliments on changes.
  @Input() item_data?; // if data.model is sent : Observable<any[]>;

  @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
  @Input() item_user_level_id? = '5'; // default to agent just in case
  @Input() item_brand_type_id? = '';
  @Input() show_buttons? = 'no'; // yes | no
  @Input() widget_title? = '';
  @Input() widget_size? = 'side'; // side | abstract | full

  job: Object;
  @Input() job_id;
  // Gets the file id and attaches to email as a default. if set to 1 and file_id set.
  @Input() is_resend_file? = 0;
  @Input() file_id? = null;
  @Input() invoice_id? = null;
  @Input() work_order_id? = null;

  @Input() intialCount? = 221;
  @Input() count? = this.intialCount;

  @Input() subject_number: number;

  @Output('closeParentModel') closeParentModel: EventEmitter<any> = new EventEmitter();
  // :: Part of this modal
  // @Output('closeParentModelDefault') closeParentModelDefault: EventEmitter<any> = new EventEmitter();

  // Function below pushes form to allRecipients array, and closes window.
  // :: Part of this modal
  //  @Output('addRecipientFromModal') addRecipientFromModal: EventEmitter<any> = new EventEmitter();

 // model: AllRecipients;
job_plaintiff_types: Object;
 subject_id: any;

 allAttachedFiles: any = [];
 allEmailRecipients: any = [];
 allClientEmailRecipients: any = [];
 allLoginEmailRecipients: any = [];
 allClientInvoiceEmailRecipients: any = [];

//  model: SubjectCommunication;
model;
allAttachments = [];
 allRecipients = [];
modalRef: BsModalRef;


   // variables for richtexteditor as form
   @ViewChild('fromRTE')
   private rteEle: RichTextEditorComponent;
 
   public tools: object = {
     items: [
       'Undo',
       'Redo',
       '|',
       'Bold',
       'Italic',
       'Underline',
       'StrikeThrough',
       '|',
       'FontName',
       'FontSize',
       'FontColor',
       'BackgroundColor',
       '|',
       'SubScript',
       'SuperScript',
       '|',
       'LowerCase',
       'UpperCase',
       '|',
       'Formats',
       'Alignments',
       '|',
       'OrderedList',
       'UnorderedList',
       '|',
       'Indent',
       'Outdent',
       '|',
       'CreateLink',
       'Image',
       '|',
       'ClearFormat',
       'Print',
       'SourceCode',
       '|',
       'FullScreen',
     ],
   };
  sent_email_widget_response: any;
  set_job_file: number;
  set_subject_file: number;
 

constructor(
  private http: HttpClient, private _demoService: DemoService,
  private route: ActivatedRoute, public toastr: HotToastService,
   vcr: ViewContainerRef, 
   public HttpClient:HttpClient,
   private fileUploader: FileUploaderService,
   private _mysqlService: MysqlService,
   private modalService: BsModalService,
   public datepipe: DatePipe,
   public gfunc: GlobalFunctionsService
) { }

// check for changes. to load data.
ngOnChanges(changes) {

  // this.model = new SubjectCommunication();
  // this.model.job_id = this.job_id;
 // this.model.recipient_type_name = 'External';
//  this.getJobPlaintiffTypes();

  if (changes.item_id) {
    // deal with asynchronous Observable result
          //  this.subject_id = changes.item_id.currentValue;
          //  this.model.subject_id = this.subject_id;
          //  this.model.subject_number = this.subject_number;
    // this.getJob(this.job_id);
  }
}


ngOnInit() {

  this.model = new SubjectCommunication();
  this.model.job_id = this.job_id;

  this.subject_id = this.item_id;
  this.model.subject_id = this.subject_id;
  this.model.subject_number = this.subject_number;

}

// Functions
getJob(job_id) {
this._demoService.getJobID(job_id).subscribe(
   data => { this.job = data;
    let res = data[0];
    // Run the job data queries.
  },
   err => console.error(err),
   // () => console.log('done loading Trace Types')
 );
}

addJobPlaintiff(model) {
this._demoService.addJobPlaintiff(model).subscribe(
  data => { },
  err => console.error(err),
  // () => console.log('done loading Trace Types')
);
this.toastr.info('Plaintiff & Type Added');
this.closeParentModel.emit();
}


getJobPlaintiffTypes() {
this._demoService.getJobPlaintiffTypes().subscribe(
   data => { this.job_plaintiff_types = data; },
   err => console.error(err),
   // () => console.log('done loading Trace Types')
 );
}



// :: Send Email Functions


sendEmail(model){
model.doc_id = 0; // set the doc_id as is needed to run the email script.
// this.gfunc.sendEmailWidgetFunction(model);



// console.log('Send Email Model: ', JSON.stringify(model));


this.gfunc.sendEmail(model); // now a global function



// this._mysqlService.sendEmailWidget(model).subscribe(
//   data => { this.sent_email_widget_response = data;
 this.toastr.success('Email Sent: ' + model.message_subject);
 this.onOpenDialog_SuccessSendEmail(model, model);

 

 //   },
//   err => console.error(err),
//   // () => console.log('done loading Trace Types')
// );

}


// syncfusion dialog simple sample
public onOpenDialog_SuccessSendEmail = function(event: any, model): void {
  this.DialogObj = DialogUtility.confirm({
    title: 'Succesfully Sent Email.',
    content: 'You may close this window to cotinue.',
    okButton: {  text: 'Ok', click: this.okClick_SuccessSendEmail.bind(this, model) },
  // cancelButton: {  text: '.', click: this.cancelClick.bind(this) },
  cancelButton: {  text: '', click: this.okClick_SuccessSendEmail.bind(this, model) },
  showCloseIcon: true,
    closeOnEscape: true,
    animationSettings: { effect: 'Zoom' }
});
}
public okClick_SuccessSendEmail(this, model): void {
 //  alert('you clicked Yes, Please! are you really really sure??? Really');
 // this.createJobSubjectsMultiple(this.JSON_job);
 this.closeParentModel.emit();
 this.DialogObj.hide();
 this.gfunc.globalJobSubjectView(model.subject_id);


}; // end functiiom

public cancelClick2_SuccessSendEmaild(this, model): void {
   // alert('you clicked Cancel button');
   this.DialogObj.hide();
}





// :: Method to all default recipients
  setAllRecipients(model) {
    this.allRecipients = [];

  if (model.send_to_report == 1) {
    // 
          // :: Impliments automatic recipients based on chosen com template options
          // :: Subract Method / Filter
          // :: DEMOSERVICE look up client brand details.
          this._demoService.getBrandById(model.brand_report_id).subscribe(
            (data) => {
              // let newArr = Object(data).filter((sbi)=>(sbi.invoice_status === 'NOT-INVOICED')); // User this if filter is needed.
             let newArr = data;
             let  count_of_items = Object.keys(newArr).length;
               // need to do a loop of subject_billing items (.length)
               for(let i=0;i < count_of_items; i++) {
               let res = newArr[i];
               this.allRecipients.push({
                 recipient_name: res.name + ' - Client Report',
                 recipient_email_address: res.email,
                 recipient_brand_id: res.brand_id,
                 recipient_brand_type_id: res.brand_type_id,
                 recipient_user_id: null,
                 recipient_user_level_id: null,
                 recipient_type_name: 'Client Report',
               });
               } // end for loop
             this.allRecipients = this.allRecipients; // ?? this may be causing errors.

            },
            (err) => console.error(err),
            () => console.log('Client Report Recipient Added.')
          );

      } // end if send_to_report
        
      // AGENT
      if ( model.brand_type_id == 3) { 
        this._demoService.getSubjectAgentBrandsAssigned(model.subject_id).subscribe(
          (data) => {
            // let newArr = Object(data).filter((sbi)=>(sbi.invoice_status === 'NOT-INVOICED')); // User this if filter is needed.
           let newArr = data;
           let  count_of_items = Object.keys(newArr).length;
             // need to do a loop of subject_billing items (.length)
             for(let i=0;i < count_of_items; i++) {
             let res = newArr[i];
             this.allRecipients.push({
               recipient_name: res.name + ' - Agent',
               recipient_email_address: res.email,
               recipient_brand_id: res.brand_id,
               recipient_brand_type_id: res.brand_type_id,
               recipient_user_id: null,
               recipient_user_level_id: null,
               recipient_type_name: 'Agent',
             });
             } // end for loop
           this.allRecipients = this.allRecipients; // ?? this may be causing errors.

          },
          (err) => console.error(err),
          () => console.log('Agent Recipients Added.')
        );
        // const key = 'Agent';
        // this.allRecipients.forEach((value, index) => {
        //   if (value.recipient_type_name === key) {
        //     this.allRecipients.splice(index, 1);
        //     console.log('Removed Agent Recipients');
        //   }
        // });
      };

      if (model.send_to_report_user == 1) {

        this._demoService.getUsersById(model.brand_report_user_id).subscribe(
          (data) => {
            // let newArr = Object(data).filter((sbi)=>(sbi.invoice_status === 'NOT-INVOICED')); // User this if filter is needed.
           let newArr = data;
           let  count_of_items = Object.keys(newArr).length;
             // need to do a loop of subject_billing items (.length)
             for(let i=0;i < count_of_items; i++) {
             let res = newArr[i];
             this.allRecipients.push({
            recipient_name: res.first_name +  ' ' + res.surname + ' - Client Report User',
            recipient_email_address: res.email_address,
            recipient_brand_id: null,
            recipient_brand_type_id: null,
            recipient_user_id: res.user_id,
            recipient_user_level_id: res.access_level,
            recipient_type_name: 'Client Report User',
             });
             } // end for loop
           this.allRecipients = this.allRecipients; // ?? this may be causing errors.

          },
          (err) => console.error(err),
          () => console.log('Client Report User Recipient Added.')
        );
        // const key = 'Client Report User';
        // this.allRecipients.forEach((value, index) => {
        //   if (value.recipient_type_name === key) {
        //     this.allRecipients.splice(index, 1);
        //     console.log('Removed Report User Recipient');
        //   }
        // });
      };

      if (model.send_to_invoice == 1) {
          this._demoService.getBrandById(model.brand_invoice_id).subscribe(
            (data) => {
              // let newArr = Object(data).filter((sbi)=>(sbi.invoice_status === 'NOT-INVOICED')); // User this if filter is needed.
             let newArr = data;
             let  count_of_items = Object.keys(newArr).length;
               // need to do a loop of subject_billing items (.length)
               for(let i=0;i < count_of_items; i++) {
               let res = newArr[i];
               this.allRecipients.push({
                 recipient_name: res.name + ' - Client Accounts',
                 recipient_email_address: res.email,
                 recipient_brand_id: res.brand_id,
                 recipient_brand_type_id: res.brand_type_id,
                 recipient_user_id: null,
                 recipient_user_level_id: null,
                 recipient_type_name: 'Client Accounts',
               });
               } // end for loop
             this.allRecipients = this.allRecipients; // ?? this may be causing errors.

            },
            (err) => console.error(err),
            () => console.log('Client Accounts Recipient Added.')
          );
      }

      if (model.send_to_logins == 1) {
        this._demoService.getBrandUsers(model.brand_report_id).subscribe(
          (data) => {
            // let newArr = Object(data).filter((sbi)=>(sbi.invoice_status === 'NOT-INVOICED')); // User this if filter is needed.
           let newArr = data;
           let  count_of_items = Object.keys(newArr).length;
             // need to do a loop of subject_billing items (.length)
             for(let i=0;i < count_of_items; i++) {
             let res = newArr[i];
             this.allRecipients.push({
            recipient_name: res.first_name +  ' ' + res.surname + ' - Client User',
            recipient_email_address: res.email_address,
            recipient_brand_id: null,
            recipient_brand_type_id: null,
            recipient_user_id: res.user_id,
            recipient_user_level_id: res.access_level,
            recipient_type_name: 'Client User',
             });
             } // end for loop
           this.allRecipients = this.allRecipients; // ?? this may be causing errors.

          },
          (err) => console.error(err),
          () => console.log('Client User Recipient Added.')
        );
        // const key = 'Client User';
        // this.allRecipients.forEach((value, index) => {
        //   if (value.recipient_type_name === key) {
        //     this.allRecipients.splice(index, 1);
        //     console.log('Removed Client User Recipients');
        //   }
        // });
      }

      if (model.send_to_primary == 1) {
        this._demoService.getBrandPrimaryContact(model.brand_report_id).subscribe(
          (data) => {
            // let newArr = Object(data).filter((sbi)=>(sbi.invoice_status === 'NOT-INVOICED')); // User this if filter is needed.
           let newArr = data;
           let  count_of_items = Object.keys(newArr).length;
             // need to do a loop of subject_billing items (.length)
             for(let i=0;i < count_of_items; i++) {
             let res = newArr[i];
             this.allRecipients.push({
            recipient_name: res.first_name +  ' ' + res.surname + ' - Client Primary Contact',
            recipient_email_address: res.email_address,
            recipient_brand_id: null,
            recipient_brand_type_id: null,
            recipient_user_id: res.user_id,
            recipient_user_level_id: res.access_level,
            recipient_type_name: 'Client Primary Contact',
             });
             } // end for loop
           this.allRecipients = this.allRecipients; // ?? this may be causing errors.

          },
          (err) => console.error(err),
          () => console.log('Client Primary Contact Added.')
        );
       
       
        // const key = 'Primary Contact';
        // this.allRecipients.forEach((value, index) => {
        //   if (value.recipient_type_name === key) {
        //     this.allRecipients.splice(index, 1);
        //     console.log('Removed Primary Contact Recipient');
        //   }
        // });
      }

} // end function


 // Removes Email From Main List. (by ID's)

 RemoveElementFromAllEmailRecipients(key: number) {
  // removes agents
  this.allEmailRecipients.forEach((value, index) => {
    if (value.brand_id === key) {
      this.allEmailRecipients.splice(index, 1);
    }
  });
  // removes clients Report
  this.allClientEmailRecipients.forEach((value, index) => {
    if (value.brand_id === key) {
      this.allClientEmailRecipients.splice(index, 1);
    }
  });
  // removes clients Invoice
  this.allClientInvoiceEmailRecipients.forEach((value, index) => {
    if (value.brand_id === key) {
      this.allClientInvoiceEmailRecipients.splice(index, 1);
    }
  });
  // removes Login Users
  this.allLoginEmailRecipients.forEach((value, index) => {
    if (value.user_id === key) {
      this.allLoginEmailRecipients.splice(index, 1);
    }
  });

  // removes all attachments
  this.allAttachments.forEach((value, index) => { 
    if (value.file_name === key) {
      this.allAttachments.splice(index, 1);
    }
  });
}

RemoveElementFromAllRecipients(key: number) {
  // removes all matching names, so it can remove multiple accidently. if they have different roles. etc
  this.allRecipients.forEach((value, index) => {
    if (value.recipient_name === key) {
      this.allRecipients.splice(index, 1);
    }
  });

    // :: Specifcally removes the array item without there being
    // :: @https://stackoverflow.com/questions/5767325/how-can-i-remove-a-specific-item-from-an-array

};



onAdd(data) {
  if (confirm('Are you sure you want to Attatch this file? ')) {
   // this.selectedFeatures.push(fileName);
    // push to global array

console.log('Send Subject ID: ' + data.file_subject_id + ' JObID: ' + data.file_job_id);

    if (data.file_subject_id  >= 1) {
      this.set_job_file = 0;
      this.set_subject_file = 1;
    }

    if (data.file_subject_id  <= 0) {
      this.set_job_file = 1;
      this.set_subject_file = 0;
    }

   // this.allAttachedFiles.push(data.full_file_name); -- commented out november 20022
    this.allAttachments.push({
      file_name: data.full_file_name,
      job_file: this.set_job_file,
      subject_file: this.set_subject_file,
      subject_number: data.subject_number,
      job_id: data.job_id,
      file_server_location: data.file_server_location
    });

this.allAttachedFiles = this.allAttachedFiles;
this.model.allAttachedFiles = this.allAttachedFiles;
this.model.allAttachments = this.allAttachments;

// this.toastr.success('Attatchment added.');
   // this.isShow = !this.isShow; // hides the div again
    // this.isShow_uploaded = !this.isShow_uploaded;

    // closes the model when opened from file browser.
    this.modalRef.hide();
  }
}





// :: Parent / Child modal test
// closeParentModelDefault(model) {
  closeParentModelDefault() {
  // alert('parent component function.');
 // this.modalService.hide(1); - removed the scroll bard do not use!!!
  this.modalRef.hide();
 // this.getJobPlaintiffs(this.job_id);
 // this.refreshGrid(); // resets the grid if updated and closed.
//  this.updateTypeClick = false; // closes the div
// :: reset the entire page.
// this.gfunc.globalJobSubjectViewSkipRoute(this.subject_id);
};


// :: Parent / Child modal test
addRecipientFromModal(model) {
  // alert('parent component function.');
 // this.modalService.hide(1); - removed the scroll bard do not use!!!
  // this.modalRef.hide();
 // this.getJobPlaintiffs(this.job_id);
 // this.refreshGrid(); // resets the grid if updated and closed.
//  this.updateTypeClick = false; // closes the div
// :: reset the entire page.
// this.gfunc.globalJobSubjectViewSkipRoute(this.subject_id);

this.allRecipients.push({
  recipient_name: model.recipient_name + ' - ' + model.recipient_type_name,
  recipient_email_address: model.recipient_email_address,
  recipient_brand_id: null,
  recipient_brand_type_id: null,
  recipient_user_id: null,
  recipient_user_level_id: null,
  recipient_type_name: model.recipient_type_name,
});

this.allRecipients = this.allRecipients;
this.model.allRecipients = this.allRecipients;

this.modalRef.hide();
// console.log('Added External Recipeint.');
// this.toastr.info('External Recipient Added');
};


  // MODAL
  // start of modal windows service as a template
// start of modal windows service as a template
openModal(template: TemplateRef<any>) {
  // small upgrade to disable background click on open modal background
  const config = { backdrop: true, ignoreBackdropClick: true, class: 'gray modal-lg' };
  this.modalRef = this.modalService.show(template, config);
}



}
